<template>
    <div class="flex gap-4">
        <!-- Buttons -->
        <button
            @click="openPracticePlan"
            class="
                px-4
                py-2
                bg-primary
                text-white
                rounded
                shadow
                hover:bg-primary-dark
                font-bold
            "
        >
            View Practice Plan
        </button>
        <button
            @click="openGamePlan"
            class="
                px-4
                py-2
                bg-green-600
                text-white
                rounded
                shadow
                hover:bg-green-700
                font-bold
            "
        >
            View Game Plan
        </button>

        <!-- Modals -->
        <ModalCustom
            :is-open="isPracticePlanOpen"
            @close="isPracticePlanOpen = false"
            z-index="100"
        >
            <div class="max-h-[90vh] overflow-y-auto">
                <PracticePlanContainer
                    v-if="practicePlanData"
                    :team="practicePlanData.team"
                    :available-tags="practicePlanData.availableTags"
                    :initial-plans="practicePlanData.plans"
                    :has-access="practicePlanData.hasAccess"
                    :can-manage-access="practicePlanData.canManageAccess"
                    :current-access-tags="practicePlanData.currentAccessTags"
                />
                <div v-else class="p-8 text-center">Loading...</div>
            </div>
        </ModalCustom>

        <ModalCustom
            :is-open="isGamePlanOpen"
            @close="isGamePlanOpen = false"
            z-index="100"
        >
            <div class="max-h-[90vh] overflow-y-auto">
                <GamePlanContainer
                    v-if="gamePlanData"
                    :team="gamePlanData.team"
                    :available-tags="gamePlanData.availableTags"
                    :initial-plans="gamePlanData.plans"
                    :has-access="gamePlanData.hasAccess"
                    :can-manage-access="gamePlanData.canManageAccess"
                    :current-access-tags="gamePlanData.currentAccessTags"
                />
                <div v-else class="p-8 text-center">Loading...</div>
            </div>
        </ModalCustom>
    </div>
</template>

<script setup>
import { ref, defineProps } from "vue";
import axios from "axios";
import ModalCustom from "../ModalCustom.vue";
import PracticePlanContainer from "./PracticePlanContainer.vue";
import GamePlanContainer from "./GamePlanContainer.vue";

const props = defineProps({
    teamId: {
        type: [Number, String],
        required: true,
    },
});

const isPracticePlanOpen = ref(false);
const isGamePlanOpen = ref(false);

const practicePlanData = ref(null);
const gamePlanData = ref(null);

const openPracticePlan = async () => {
    isPracticePlanOpen.value = true;
    if (!practicePlanData.value) {
        try {
            const res = await axios.get("/practice_plans", {
                params: { teamId: props.teamId },
                headers: { Accept: "application/json" },
            });
            practicePlanData.value = res.data;
        } catch (error) {
            console.error("Failed to fetch Practice Plans", error);
        }
    }
};

const openGamePlan = async () => {
    isGamePlanOpen.value = true;
    if (!gamePlanData.value) {
        try {
            const res = await axios.get("/game_plans", {
                params: { teamId: props.teamId },
                headers: { Accept: "application/json" },
            });
            gamePlanData.value = res.data;
        } catch (error) {
            console.error("Failed to fetch Game Plans", error);
        }
    }
};
</script>

<style scoped>
.bg-primary {
    background-color: #1b6fc3;
}
.bg-primary-dark {
    background-color: #155594;
}
</style>
